import { SHOW_TOAST, HIDE_TOAST, CLEAR_ALL_TOAST } from '../../ActionsConst';

const initialState = [];
const config = (state = initialState, action) => {
  /* Keep the reducer clean - do not mutate the original state. */
  // let nextState = Object.assign({}, state);

  switch (action.type) {
    case SHOW_TOAST:
      // add the new toast to the end
      return [...state, ...action.toast];
    case HIDE_TOAST:
      // filter out the toast based on id
      return state.filter((toast) => toast.id !== action.id);
    case CLEAR_ALL_TOAST:
      // return an empty toast array to remove them from screen
      return [];

    default: {
      /* Return original state if no actions were consumed. */
      return state;
    }
  }
};

export default config;
